const state = {
  promos: [],
  isPromosLoading: false,
};

export default state;
